<template>
    <div class="dropdown">
        <button ref="dropdown" class="erk btn btn-light dropdown-toggle badgeNotification" type="button" id="dropdownMenuButtonGuida" data-bs-toggle="dropdown" aria-expanded="false">
            <i class="bi bi-question-circle fs-2 pe-1 align-middle"></i>
        </button>
        <ul class="dropdown-menu dropdown-menu-end bg-primary notify-drop" aria-labelledby="dropdownMenuButtonGuida">
            <div class="notify-drop-title">
                <div class="row">
                    <div class="col-md-6 col-sm-6 col-xs-6">Guida</div>
                </div>
            </div>
            
            <div class="drop-content p-3">
                <div v-if="text" v-html="text"></div>
            </div>
            <div class="guida-drop-footer text-center pt-1">
                <a href="/files/doc/Guida_ePRO.pdf" target="_blank">Scarica la guida completa</a>
            </div>
        </ul>

    </div>
</template>
<script>

export default {
    name: 'MbGuidaWidget',
    props: {
        text: String
    },
    data() {
        return {
        }
    },
    computed: {
    },
    mounted(){
    },
    methods: {
    }
}

</script>